__turbopack_context__.v({
  "close": "fR3u_a_close",
  "container": "fR3u_a_container",
  "copy": "fR3u_a_copy",
  "copy-row": "fR3u_a_copy-row",
  "description": "fR3u_a_description",
  "dialog": "fR3u_a_dialog",
  "footer": "fR3u_a_footer",
  "footer-copy": "fR3u_a_footer-copy",
  "footer-text": "fR3u_a_footer-text",
  "footer-title": "fR3u_a_footer-title",
  "image": "fR3u_a_image",
  "image-picture": "fR3u_a_image-picture",
  "modal": "fR3u_a_modal",
  "modal-pop": "fR3u_a_modal-pop",
  "overlay": "fR3u_a_overlay",
  "overlay-fade": "fR3u_a_overlay-fade",
  "search": "fR3u_a_search",
  "search-button": "fR3u_a_search-button",
  "search-button__icon": "fR3u_a_search-button__icon",
  "search-error": "fR3u_a_search-error",
  "search-icon": "fR3u_a_search-icon",
  "search-input": "fR3u_a_search-input",
  "search-input--error": "fR3u_a_search-input--error",
  "title": "fR3u_a_title",
});
